export default __webpack_public_path__ + "static/media/amex-logo.b2ae001c.png";